var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionButton',{on:{"click":_vm.copyNToFN},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconCopy',{attrs:{"size":20}})]},proxy:true}])},[_vm._v("\n\t"+_vm._s(_vm.t('contacts', 'Copy to full name'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }